import { withInstall } from '@zoryn/utils'
import Grid from './src/grid'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZGrid: SFCWithInstall<typeof Grid> = withInstall(Grid)
export default ZGrid

export type {
  GridOptions,
  GridColumnProps,
  GridColumnInfo,
  GridBtn,
  GridSearchField,
  GridSearchFieldMode,
  GridFilter,
  GridFilterOperator,
  GridFilterGroupState,
  FilterPayloadNode,
  GridQueryParams,
  GridFooterMethod,
  GridToDetailConfig,
  GridToDetailFn,
  GridInputTablePickerOptions,
  DataGrid,
  DataGridBase,
  GridReactData,
  GridValidErrorItem,
  GridContextMenuItem,
  GridContextMenuOptions,
  GridContextMenuContext,
  GridContextMenuItemContext,
  GridContextMenuClickContext,
  GridContextMenuStore,
  GridAiIntent,
  GridAiSort,
  GridAiFilterItem,
  GridAiFilters,
  GridAiColumnVisibility,
  GridAiCommand,
  GridAiPromptContextColumn,
  GridAiPromptContext,
  GridAiPromptResolver,
  GridAiAssistantOptions,
  GridAiPromptVariant,
  GridAiPrompt,
  GridAiConversation,
  GridAiAssistantStore,
} from './src/types'
export { GridOption } from './src/grid-option'
export type { GridOptionConfig, GridOptionConstructor } from './src/grid-option'
export type { GridConfigContext } from './src/types/grid-config-context'
export { parsePageResult } from './src/api/api-convention'
export type { BaseControllerPageResult } from './src/api/api-convention'
export { GRID_HTTP_INJECTION_KEY } from './src/constants/grid-http'
export {
  ensureGridRequest,
  resolveGridRequest,
} from './src/utils/resolve-grid-request'
export {
  buildGridDetailRowKey,
  GRID_DETAIL_ROW_PREFIX,
  readGridDetailRow,
  resolveDetailRowFromQuery,
  resolveDetailRowId,
  resolveDetailRowQueryValue,
  saveGridDetailRow,
} from './src/utils/detail-row-store'
export { useGridDetailRow } from './src/hooks/use-grid-detail-row'
